import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {Organization} from '../../entity/model/organization';

export default class OrganizationAgent {

  getOrganizations = async (): Promise<Organization[]> => {
    return await API.get(awsApiName, '/organizations', {});
  }

  getOrganizationById = async (organizationId: string): Promise<Organization> => {
    return await API.get(awsApiName, '/organizations/' + organizationId, {});
  }
}